<div class="tab-container">
  <div class="tabs rush-default-color">
    <div class="items">
      @for (tab of tabs; track tab.name) {
        <app-tab [tab]="tab"></app-tab>
      }
    </div>
  </div>
  <div class="tab-content relative">
    <app-rush [class.hide]="activeTab.name !== tabNamesEnums.RUSH"></app-rush>
    <app-classic [class.hide]="activeTab.name !== tabNamesEnums.CLASSIC"></app-classic>
  </div>
</div>
